import { c as _c } from "react/compiler-runtime";
import { MarkdownText } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import type { Components } from 'react-markdown';

// An add (ghost) card has no prior value to diff, so it renders Percy's proposed markdown
// formatted — unlike refine cards, which show a plain-text WordDiff. Headings match the sizes
// prose-preview.tsx uses so the preview reads like the field once accepted.
const compactMarkdownComponents: Components = {
  h1: ({
    children
  }: {
    children?: ReactNode;
  }) => <h1 className="text-heading-3">{children}</h1>,
  h2: ({
    children
  }: {
    children?: ReactNode;
  }) => <h2 className="text-label-1">{children}</h2>,
  h3: ({
    children
  }: {
    children?: ReactNode;
  }) => <h3 className="text-label-2">{children}</h3>
};
type SuggestionProseProps = {
  children: string;
};
const SuggestionProse = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="text-body-3 text-secondary leading-snug"><MarkdownText components={compactMarkdownComponents}>{children}</MarkdownText></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SuggestionProse;